// extracted by mini-css-extract-plugin
export default {"providersTable":"List_providersTable__u7gmh"};